// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__lbtDN","gfeWrapper":"CalendarEvent_gfeWrapper__2r5Yg"};